import { configureStore } from "@reduxjs/toolkit";
// reducers
import authReducer from "./auth";
import cartReducer from "./cart";
import carReducer from "./car";
import menuTracker from "./menuTracker";
import mechanicReducer from "./mechanic";
import orderReducer from "./order";

const store = configureStore({
  reducer: {
    auth: authReducer,
    cart: cartReducer,
    car: carReducer,
    menuTracker: menuTracker,
    mechanic: mechanicReducer,
    order: orderReducer,
  },
  devTools: !process.env.NODE_ENV || process.env.NODE_ENV === "development",
});

export default store;
